/**
 * User: WangMeng
 * Date: 2018-07-17
 * Time: 17:45
 * Desc: 海外业务占比较大
 */

import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';

export default class OverseasIncome extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.title = '收入结构（地区分布）';
        this.searchParam = {};
    }

    getColumns = () => {
        return [{
            title: '地区',
            dataIndex: 'area'
        }, {
            title: '当期营业收入',
            dataIndex: 'currentInco'
        }, {
            title: '上期营业收入',
            dataIndex: 'beforeInco'
        }];
    };
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialRiskAnalysis/subComponents/danger/OverseasIncome.jsx